// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"classes_Paragraph__24i9I","list":"classes_list__3qt3c"};